<template>
    <div class="yh-page">
      <el-card>
        <el-row slot="header" type="flex" justify="space-between" align="middle" class="p-3" :gutter="10">
          <el-col :span="15">
            <el-input placeholder="输入船东信息进行搜索..." v-model.trim="query.search"
                      @keyup.enter.native="handleSearch">
              <el-button slot="append" icon="el-icon-search" v-loading="searching" @click="handleSearch">搜索</el-button>
            </el-input>

          </el-col>
          <el-col :span="6">
          <el-select placeholder="请选择状态" v-model="query.status" filterable clearable @change="handleSearch">
              <el-option v-for="g in statusList" :key="g.id" :value="g.value" :label="g.name"></el-option>
            </el-select>
          </el-col>
          <el-col :span="6">
          <el-select placeholder="请选择财务状态" v-model="query.finance_status" filterable clearable @change="handleSearch">
              <el-option v-for="g in financeStatusList" :key="g.id" :value="g.value" :label="g.name"></el-option>
            </el-select>
          </el-col>
          <el-col :span="6">
          <el-select placeholder="请选择业务部门" v-model="query.department" filterable clearable @change="handleSearch">
            <el-option v-for="g in groupList" :key="g.id" :value="g.name"></el-option>
          </el-select>
          </el-col>
          <el-col :span="3">
            <el-button type="primary" size="small"  @click="shipQuitApplyExport">导出收款委托书</el-button>
          </el-col>
          <el-col :span="3">
            <el-button type="primary" size="small"  @click="shipQuitExport">退会/变更申请书（正常）</el-button>
          </el-col>
          <el-col :span="3">
            <el-button type="primary" size="small"  @click="shipQuitExportDeatil">退会/变更申请书(不能冲红)</el-button>
          </el-col>
        </el-row>
        <div>
          <el-table :key="0" :data="list" stripe v-loading="listLoading" :element-loading-text="loadingText" fit
                    highlight-current-row class="w-100" @selection-change="handleSelectionChange">
            <!-- 客户名称 -->
            <el-table-column
              type="selection"
              width="30">
            </el-table-column>
            <el-table-column align="left" label="id" width="60">
              <template slot-scope="scope">
                <span>{{scope.row.id}}</span>
              </template>
            </el-table-column>

            <el-table-column align="left" label="会员名称">
              <template slot-scope="scope">
                <span>{{scope.row.member_name}}</span>
              </template>
            </el-table-column>
            <el-table-column align="left" label="船名">
              <template slot-scope="scope">
                <div v-for="(i, index) in scope.row.ship_name.split(',')" :key="index">{{ i }}</div>
              </template>
            </el-table-column>
            <el-table-column align="left" label="退出状态" width="100">
              <template slot-scope="scope">
                <span>{{scope.row.status_name}}</span>
              </template>
            </el-table-column>

            <el-table-column align="left" label="财务部审核状态">
              <template slot-scope="scope">
                <span>{{scope.row.finance_status_name}}</span>
              </template>
            </el-table-column>

            <!-- <el-table-column align="left" label="是否退风险准备金">
              <template slot-scope="scope">
                <span>{{scope.row.is_account == 1 ? "是":"否"}}</span>
              </template>
            </el-table-column> -->

            <el-table-column align="left" label="退风险准备金金额" width="110">
              <template slot-scope="scope">
                <span>{{scope.row.account}}</span>
              </template>
            </el-table-column>

            <el-table-column align="left" label="调差金额" width="110">
              <template slot-scope="scope">
                <span>{{scope.row.adjustment_amount}}</span>
              </template>
            </el-table-column>

            <el-table-column align="left" label="实际支付金额" width="110">
              <template slot-scope="scope">
                <span>{{scope.row.actual_amount}}</span>
              </template>
            </el-table-column>
       
            <!-- 更新人 -->
            <!-- <el-table-column align="left" label="创建人">
              <template slot-scope="scope">
                <span>{{scope.row.updater_name ? scope.row.updater_name :scope.row.creator_name}}</span>
              </template>
            </el-table-column> -->

            <!-- 创建时间 -->
            <el-table-column align="left" label="创建时间" width="110">
              <template slot-scope="scope">
                <span>{{ scope.row.create_time | parseTime }}</span>
              </template>
            </el-table-column>

            <!-- 申请时间 -->
            <el-table-column align="left" label="提交申请时间" width="110">
              <template slot-scope="scope">
                <span>{{ scope.row.submit_time | parseTime }}</span>
              </template>
            </el-table-column>

            
            <el-table-column align="left" label="预计退费时间" width="110">
              <template slot-scope="scope">
                <span>{{scope.row.quit_time | parseTime}}</span>
              </template>
            </el-table-column>
    
            <el-table-column align="left" label="操作">
              <template slot-scope="scope">
                <el-tooltip effect="light" content="提交审核" placement="top-start" v-show="[0,3].indexOf(scope.row.status) !== -1">
                  <el-button type="text" class="pr-1" @click="handleSubmit(scope.row)">
                    <i class="el-icon-s-promotion"></i>
                  </el-button>
                </el-tooltip>
                <el-tooltip effect="light" content="审核" placement="top-start" v-if="scope.row.status == 1 && $perm(['member.auditing_ship_quit_apply'])">
                    <el-button type="text" class="pr-1" @click="handleSuccess(scope.row)">
                        <i class="el-icon-document-checked"></i>
                    </el-button>
                </el-tooltip>
                <el-tooltip effect="light" placement="top-start" content="编辑" v-show="[0,3].indexOf(scope.row.status) !== -1">
                  <el-button type="text" @click="handleEdit(scope.row)">
                    <i class="el-icon-edit"></i>
                  </el-button>
                </el-tooltip>

                
                <el-tooltip effect="light" placement="top-start" content="业务主管审核" >
                  <el-button type="text" @click="handleBusinessAuditing(scope.row)" v-show="[9].indexOf(scope.row.status) !== -1">
                    <i class="el-icon-s-check"></i>
                  </el-button>
                </el-tooltip>

                <el-tooltip effect="light" placement="top-start" content="审核或调整差额" v-if="[0,3].indexOf(scope.row.finance_status) !== -1  && scope.row.status == 2  && $perm(['member.update_ship_quit_apply'])">
                  <el-button type="text" @click="handleAdjust(scope.row)">
                    <i class="el-icon-sort"></i>
                  </el-button>
                </el-tooltip>
                
                <el-tooltip effect="light" placement="top-start" content="查看">
                    <el-button type="text" @click="handleUpdate(scope.row)" ><i class="el-icon-view"></i></el-button>
                </el-tooltip>

                
                <el-tooltip effect="light" placement="top-start" content="撤销申请">
                  <el-button type="text" @click="handleDelete(scope.row)" v-show="[0,1,2,3,4,8].indexOf(scope.row.status) !== -1 && $perm(['member.delete_ship_quit_apply'])">
                    <i class="el-icon-refresh-right"></i>
                  </el-button>
                </el-tooltip>

                
                <el-tooltip effect="light" placement="top-start" content="撤销申请确认" >
                  <el-button type="text" @click="handleDeleteApply(scope.row)" v-show="[6].indexOf(scope.row.status) !== -1">
                    <i class="el-icon-circle-check"></i>
                  </el-button>
                </el-tooltip>

                <el-tooltip effect="light" placement="top-start" content="确认打款" >
                  <el-button type="text" @click="handleAuditing(scope.row)" v-show="[8].indexOf(scope.row.status) !== -1 && $perm(['member.update_ship_quit_apply']) && [1].indexOf(scope.row.finance_status) !== -1 ">
                    <i class="el-icon-success"></i>
                  </el-button>
                </el-tooltip>

                <el-tooltip effect="light" placement="top-start" content="导出记录" >
                  <el-button type="text" @click="handleDownload(scope.row)" v-show="[1].indexOf(scope.row.finance_status) !== -1">
                    <i class="el-icon-download"></i>
                  </el-button>
                </el-tooltip>

                <el-tooltip effect="light" content="上传" placement="top-start">
                  <el-button type="text" class="pr-1" @click="handleUpload(scope.row)">
                    <i class="el-icon-upload"></i>
                  </el-button>
                </el-tooltip>
                <!-- <el-tooltip effect="light" content="审核不通过" placement="top-start">
                    <el-button type="text" class="pr-1" @click="handleReject(scope.row)">
                        <i class="el-icon-s-release"></i>
                    </el-button>
                </el-tooltip> -->
              </template>
            </el-table-column>
          </el-table>
          <pagination-new :size.sync="query.limit" :offset.sync="query.offset" :total="total"
                      @updateList="getList"></pagination-new>
          <upload-dialog ref="upload"
                  :object-name="object_name"
                  :file-type-list="file_type_list"
                  object-type="member.memberquitapply"
                  :object-id="apply_id"
                  :is-upload="true"
                  :ship-list="shipList" 
                  @uploaded="handleAppended">
              </upload-dialog>
              </div>
            </el-card>
      <make-document-dialog ref="makeDocument"
                            :command_list="command_list"
                            :data="multipleSelection">
      </make-document-dialog>
      <el-dialog title="创建收款委托书" :visible.sync="assignVisible" width="620px" top="20px">
      <el-form ref="dataForm" :model="formData" label-position="top" label-width="120px" class="mx-30">

        <el-form-item label="委托法定代表人" prop="name">
              <el-input  placeholder="请输入委托法定代表人" min="1" v-model="formData.name" style="width: 65%;"/> 
        </el-form-item>
        <el-form-item label="身份证">
          <el-input  placeholder="请输入身份证" min="1" v-model="formData.id_card" style="width: 65%;"/> 
        </el-form-item>
        <el-form-item label="签署日期">
              <el-date-picker
                v-model="formData.write_date"
                type="date"
                format="yyyy 年 MM 月 dd 日"
                value-format="yyyy-MM-dd"
                placeholder="选择日期">
              </el-date-picker>
        </el-form-item>

        <el-form-item style="margin-bottom: 0px">
        <span style="float: right">
          <el-button size="small" @click="cancelData">取消</el-button>
          <el-button type="primary" size="small" @click="exportApply">导出</el-button>
        </span>
      </el-form-item>
      </el-form>
    </el-dialog>
    
    <el-dialog :visible.sync="shipQuitVisible" width="50%" title="导出船舶退会/变更申请书">
      <el-form ref="dataForm" :model="quitForm" label-position="top" label-width="120px" class="mx-30">
        <el-form-item label="请选择退会原因" >
          <el-radio v-model="quitForm.reason" label="1">报废</el-radio>
          <el-radio v-model="quitForm.reason" label="2">转让</el-radio>
          <el-radio v-model="quitForm.reason" label="3">其他</el-radio>
        </el-form-item>
        <el-form-item label="其他原因" v-show="quitForm.reason === '3'">
          <el-input  type="textarea" :rows="4" placeholder="请输入其他原因"  v-model="quitForm.other_reason" style="width: 65%;"/> 
        </el-form-item>
        <el-form-item label="请选择退会类型">
          <el-radio v-model="quitForm.type" label="1" disabled>仅退船舶保留风险准备金</el-radio>
          <el-radio v-model="quitForm.type" label="2" disabled>转移风险准备金</el-radio>
          <el-radio v-model="quitForm.type" label="3" disabled>退风险准备金</el-radio>
        </el-form-item>
        <el-form-item label="请选择开票类型"  v-show="quitForm.type === '3' && export_type === 2">
          <el-radio v-model="quitForm.invoice_type" label="1">专票</el-radio>
          <el-radio v-model="quitForm.invoice_type" label="2">普票</el-radio>
        </el-form-item>
        <el-form-item label="开票金额" v-show="quitForm.type === '3'  && export_type === 2">
          <el-input  type="number" :rows="4" placeholder="请输入开票金额"  v-model="quitForm.quit_amount" style="width: 65%;"/> 
        </el-form-item>
        <el-form-item label="扣减税额" v-show="quitForm.type === '3'  && export_type === 2">
          <el-input  type="number" :rows="4" placeholder="请输入扣减税额"  v-model="quitForm.tax" style="width: 65%;"/> 
        </el-form-item>

        <el-form-item label="开票金额" v-show="quitForm.type === '3'  && export_type === 1 && multipleSelection[0].invoice_type === '冲红发票'">
          <el-input  type="number" :rows="4" placeholder="请输入开票金额"  v-model="quitForm.quit_amount" style="width: 65%;"/> 
        </el-form-item>
        <el-form-item label="请选择开票类型"  v-show="quitForm.type === '3'  && export_type === 1 && multipleSelection[0].invoice_type === '冲红发票'">
          <el-radio v-model="quitForm.invoice_type" label="1">专票</el-radio>
          <el-radio v-model="quitForm.invoice_type" label="2">普票</el-radio>
        </el-form-item>
        <el-form-item label="冲红发票号" v-show="quitForm.type === '3'  && export_type === 1 && multipleSelection[0].invoice_type === '冲红发票'">
          <el-input  placeholder="请输入冲红发票号"  v-model="quitForm.invoice_number" style="width: 65%;"/> 
        </el-form-item>
        <el-form-item label="签署日期">
              <el-date-picker
                v-model="quitForm.write_date"
                type="date"
                format="yyyy 年 MM 月 dd 日"
                value-format="yyyy-MM-dd"
                placeholder="选择日期">
              </el-date-picker>
        </el-form-item>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="cancelShipQuitVisible">取消</el-button>
        <el-button type="primary" @click="exportShipQuit">导出</el-button>
      </span>
    </el-dialog>
    </div>

  </template>
  
  <script>
    import {parseTime} from '@/utils'
    import PaginationNew from '@/components/PaginationNew'
    import {memberShipQuitApplyList,rejectShipApply,exportShipQuitApply,exportPowerAttorney,exportQuitDeatil,submitShipQuit,deleteShipQuitApply,successShipQuit} from '@/api/member'
    import UploadDialog from "@/components/UploadDialog"
    import MakeDocumentDialog from '@/views/ib/group-insurance/make-document-dialog'
    import { fetchFileTypeList } from "@/api/common"
    import { fetchList as fetchGroupList } from "@/api/group";
  
    export default {
      name: "quitShipApplyList",
      components: {
        PaginationNew,
        UploadDialog,
        MakeDocumentDialog
      },
      filters: {
        parseTime
      },
      data() {
        return {
          list:[],
          groupList:[],
          query: {
            search: '',
            offset: 0,
            limit: 20,
            type:"ShipQuitList",
          },
          searching: false,
          multipleSelection: [],
          shipList:[],
          command_list: [],
          quitForm:{},
          formData:{},
          downloading:false,
          assignVisible:false,
          shipQuitVisible:false,
          downloadingText:false,
          listLoading: false,
          loadingText: '正在加载船东数据，请稍等...',
          financeStatusList:[
          {id: 0, name: '未审核','value':0},
              {id: 1, name: '财务主管已通过','value':1},
              {id: 2, name: '财务主管已拒绝','value':2},
              {id: 3, name: '财务人员审核通过','value':3},
          ],
          statusList:[
              {id: 0, name: '已创建','value':0},
              {id: 1, name: '已提交审核','value':1},
              {id: 2, name: '已通过','value':2},
              {id: 3, name: '已拒绝','value':3},
              {id: 4, name: '退会中','value':4},
              {id: 5, name: '已退会','value':5},
              {id: 6, name: '已提交撤销申请','value':6},
              {id: 7, name: '已撤销','value':7},
              {id: 8, name: '待财务退款','value':8},
              {id: 9, name: '待业务主管审核','value':9},
            ],
          total: 0,
          object_name:'',
          apply_id:'',
        }
      },
      methods: {
        exportShipQuit(){
          if ( !this.quitForm.reason ) {
                this.$error_message("请选择退会原因！")
                return
              }
          if ( !this.quitForm.type ) {
            this.$error_message("请选择退会类型！")
            return
          }
          exportShipQuitApply({type:this.export_type,data:this.multipleSelection,reason:this.quitForm})
            .then(res => {
                let link = document.createElement('a')
                link.style.display = 'none'

                let blob = new Blob([res])
                link.href = URL.createObjectURL(blob)

                let ext_name = '.pdf'
                link.download = "船舶退会/变更申请书" + ext_name
                document.body.appendChild(link)

                link.click()
                URL.revokeObjectURL(blob)
                document.body.removeChild(link)
                this.shipQuitVisible = false
                this.downloading = false
            })
            .catch(error => {
                this.downloading = false
                let reader = new FileReader()
                reader.onload = e => {
                  if (e.target.readyState === 2) {
                    let res = {}
                    res = JSON.parse(e.target.result)
                    this.$error_message(res)
                  }
                }
                reader.readAsText(error)
            })
        },
        shipQuitExport(){
          this.quitForm = {}
          if (this.multipleSelection.length !== 1) {
                this.$error_message("请选择一条退会申请！")
                return
              }
          if (this.multipleSelection[0].is_account){
            this.quitForm.type = '3'
          } else {
            this.quitForm.type = '1'
          }
          if (['', '扣税点',null].indexOf(this.multipleSelection[0].invoice_type) !== -1){
                this.$error_message("该申请风险准备金发票状态不支持导出该文书！")
                return
          }
          

          this.export_type = 1
          this.shipQuitVisible = true
        },
        shipQuitExportDeatil(){
          this.quitForm = {}
          if (this.multipleSelection.length !== 1) {
                this.$error_message("请选择一条退会申请！")
                return
              }
          if (['', '不冲红发票',null,'冲红发票','未开具发票'].indexOf(this.multipleSelection[0].invoice_type) !== -1){
                this.$error_message("该申请风险准备金发票状态不支持导出该文书！")
                return
          }
          
          if (this.multipleSelection[0].is_account){
                this.quitForm.type = '3'
              } else {
            this.quitForm.type = '1'
          }
          this.export_type = 2
          this.shipQuitVisible = true
        },
        cancelShipQuitVisible(){
          this.shipQuitVisible = false
          this.quitForm = {}
        },

        cancelData(){
          this.assignVisible = false
        },
        handleSelectionChange(val) {
          this.multipleSelection = val;
        },
        shipQuitApplyExport(){
          if (this.multipleSelection.length === 0) {
                this.$error_message("请选择退会申请！")
                return
              }
          this.assignVisible = true
        },
        exportApply(){
          exportPowerAttorney({'power':this.formData,'data':this.multipleSelection[0]})
            .then(res => {
                let link = document.createElement('a')
                link.style.display = 'none'

                let blob = new Blob([res])
                link.href = URL.createObjectURL(blob)

                let ext_name = '.pdf'
                link.download = "收款委托书" + ext_name
                document.body.appendChild(link)

                link.click()
                URL.revokeObjectURL(blob)
                document.body.removeChild(link)
                this.assignVisible = false
                this.downloading = false
            })
            .catch(error => {
                this.downloading = false
                let reader = new FileReader()
                reader.onload = e => {
                  if (e.target.readyState === 2) {
                    let res = {}
                    res = JSON.parse(e.target.result)
                    this.$error_message(res)
                  }
                }
                reader.readAsText(error)
            })
        },
        handleDownload(row){
          this.downloading = true
            exportQuitDeatil(row.id).then(res => {
                let link = document.createElement('a')
                link.style.display = 'none'
                let blob = new Blob([res])
                link.href = URL.createObjectURL(blob)
                
                link.download = '船舶退会记录.pdf'
                document.body.appendChild(link)

                link.click()
                URL.revokeObjectURL(blob)
                document.body.removeChild(link)
                this.downloading = false
            }).catch(error => {
                this.downloading = false
                this.$error_message(error)
            })
        },
        setQueryStorage() {
          window.localStorage.setItem('query', JSON.stringify(this.query))
        },
        handleAuditing(row){
          this.$confirm('是否确认通过该申请？', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            }).then(() => {
 
              successShipQuit({id: row.id})
                  .then(res => {
                    this.$message.success(res)
                    this.getList()
                  })
                  .catch(err => {
                    this.$error_message(err)
                  })
            }).catch(() => {
              this.$message({
                type: 'info',
                message: '已取消提交'
              });          
            });
        },
        handleDeleteApply(row){
          this.$confirm('是否确认撤销该退会申请？', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            }).then(() => {
 
              deleteShipQuitApply({id: row.id,'is_quit':1})
                  .then(res => {
                    this.$message.success(res)
                    this.getList()
                  })
                  .catch(err => {
                    this.$error_message(err)
                  })
            }).catch(() => {
              this.$message({
                type: 'info',
                message: '已取消提交'
              });          
            });
        },
        handleDelete(row){
          this.$confirm('是否撤销该退会申请？', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            }).then(() => {
 
              deleteShipQuitApply({id: row.id,'is_quit':0})
                  .then(res => {
                    this.$message.success(res)
                    this.getList()
                  })
                  .catch(err => {
                    this.$error_message(err)
                  })
            }).catch(() => {
              this.$message({
                type: 'info',
                message: '已取消提交'
              });          
            });
        },
        handleAdjust(row){
          this.setQueryStorage()
          this.$router.push({ name: 'quitShipApplyDetail', query: {'type': 'ApplyAdjust', 'id': row.id}})
        },
        handleEdit(row){
          this.setQueryStorage()
          this.$router.push({ name: 'quitShipApplyDetail', query: {'type': 'ApplyUpdate', 'id': row.id}})
        },
        handleSuccess(row) {
          this.setQueryStorage()
          this.$router.push({ name: 'quitShipApplyDetail', query: {'type': 'ApplySuccess', 'id': row.id}})
        },
        handleUpdate(row){
          this.setQueryStorage()
          this.$router.push({ name: 'quitShipApplyDetail', query: {'type': 'ShowShipApply', 'id': row.id}})
        },
        handleBusinessAuditing(row){
          this.setQueryStorage()
          this.$router.push({ name: 'quitShipApplyDetail', query: {'type': 'BusinessAuditing', 'id': row.id}})
        },

        handleAppended(fileList) {
          this.$message({type: 'success', message: '文件上传成功!'})
        },
        handleUpload(row) {
          this.shipList = row.ship_list
          this.apply_id = row.id
          this.object_name = row.member_name
          this.$refs.upload.handleOpen()
        },
        loadData() {
          this.loading = true
          let p = []
          p.push(fetchFileTypeList({file_type: "group_ins|sc|bc"}))
          p.push(fetchGroupList())

          Promise.all(p)
          .then(res => {
            this.file_type_list = res[0]
            this.groupList = res[1]
          })
          .catch(err => {
            this.loading = false
            this.$error_message(err)
          })
        },
        handleSubmit(row) {
            if (!row.account_name){
              this.$error_message("缺少账户名称，无法提交，请先编辑填写！")
              return
            }
            if (!row.account_number){
              this.$error_message("缺少账号，无法提交，请先编辑填写！！")
              return
            }
            if (!row.account_address){
              this.$error_message("缺少账户开户行，无法提交，请先编辑填写！！")
              return
            }
            this.$confirm('提交审核后，将不能再修改报名内容, 是否继续?', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            }).then(() => {
              submitShipQuit({id: row.id})
              .then(res => {
                this.$message.success(res)
                this.getList()
              })
              .catch(err => {
                this.$error_message(err)
              })
            }).catch(() => {
              this.$message({
                type: 'info',
                message: '已取消提交'
              });          
            });
          },
        handleReject(row) {
          var msg = '是否拒绝该申请？'
          this.$confirm(msg, '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'info'
          }).then(() => {
            rejectShipApply({'id':row.id})
              .then(() => {
                this.$message({
                  type: 'success',
                  message: '拒绝成功!'
                })
                this.getList()
              })
              .catch(error => {
                this.$message.error(error)
              })
          })
        },
        handleSearch() {
          this.getList()
        },
        getList() {

          // 从数据库中加载用户数据
          this.listLoading = true
          memberShipQuitApplyList(this.query)

            .then(res => {
              this.list = res.results
              this.total = res.count
              this.listLoading = false
              window.localStorage.removeItem('query')
              this.$emit("toIndex", res.count)
            })
            .catch((error) => {
              this.listLoading = false
              this.$error_message(error)
            })
        },
      },
      created() {
        this.query = JSON.parse(window.localStorage.getItem('query')) || {
            search: '',
            offset: 0,
            limit: 20,
            
          }
        this.getList()
        this.loadData()
      }
    }
  </script>
  